import { store } from 'bukku/redux/store';
import { PermissionSubscriptionCheck } from 'bukku/components/Access/helper/PermissionSubscriptionCheck';
import { getSidebarOptions } from 'bukku/containers/Sidebar/options';
import _ from 'underscore';

/**

 * @param {Object[]} streams - From Flow module - dynamic data which requires fetching from API.
 *  - structure: Array of { id: Number, ext_name:String, provider: Object }
 */
export const getValidRoutes = streams => {
    const {
        Auth,
    } = store.getState();
    const { user } = Auth;

    if (!user)
        return [];
    // console.log('aaa sidebarOptions', { sidebarOptions: sidebarOptions(streams) });
    // console.log('aaa sidebarOptions', { appRoutes: appRoutes, session })

    const options = getSidebarOptions(streams).map(option => {
        const item = { ...option };
        if (item.children) {
            item.children = item.children
                .map(childOption => {
                    const parentLabel = item.globalSearchLabel ? item.globalSearchLabel : item.label;
                    const child = { ...childOption, parentLabel };

                    const access = PermissionSubscriptionCheck.withUrl(child.key).hasPermissionTo();
                    child.locked = !access.subscription;
                    child.hidden = !access.permission;

                    // override the label if there are duplicates (eg: Payments)
                    // or to make it more descriptive (eg: Items -> Product Items)
                    if (child.globalSearchLabel)
                        child.label = child.globalSearchLabel;
                    return child;
                })
                .filter(child => !child.hidden && !child.locked);

            // if (option.key === '/reports') {
            //     item.children = item.children.filter(childOption => {
            //         if (childOption.key === '/reports/all')
            //             return true
            //         return !!favouriteReports.find(r => r === childOption.key)
            //     })
            // }
            item.locked = !item.children.find(child => !child.locked);
            item.hidden = !item.children.length;
        }
        else {
            const access = PermissionSubscriptionCheck.withUrl(item.key).hasPermissionTo();
            item.locked = !access.subscription;
            item.hidden = !access.permission;
            // if (item.key === '/dashboard')
            //     item.hidden = false
        }
        return item;
    });
    console.log('aaa options', options);

    const flattenValidRoutes = options
        .filter(item => !item.hidden && !item.locked)
        .flatMap(a => {
            let newArr = [a];
            // console.log('aaa flatMap a', a);
            const parentLabel = a.globalSearchLabel ? a.globalSearchLabel : a.label;
            // Sub-Modules - eg sales/quotes, sales/invoice
            if (a.children) {
                newArr = a.children
                    .flatMap(module => {
                        if (module.globalSearchChildren) {
                            // Sub-Modules' Subgroup  - eg sales/invoice/new, sales/invoice/batch

                            // omit to perform cleanup of unused key - globalSearchChildren (already flatMap)
                            return [
                                _.omit(module, 'globalSearchChildren'),
                                ...module.globalSearchChildren
                                    .map(c => {
                                        const access = PermissionSubscriptionCheck
                                            .withUrl(c.key).hasPermissionTo();
                                        return {...c,
                                            locked: !access.subscription,
                                            hidden: !access.permission,
                                            parentLabel,
                                        };
                                    })
                                    .filter(c => !c.hidden && !c.locked),
                            ];
                            // return [module, ...module.globalSearchChildren];
                        }
                        return module;
                    });
            }

            // Modules with subgroups - eg contacts with contacts/new, contacts/batch
            if (a.globalSearchChildren) {
                // omit to perform of cleanup unused key - globalSearchChildren (already in flatMap)
                newArr = [
                    ...newArr.map(c => _.omit(c, 'globalSearchChildren')),
                    ...a.globalSearchChildren
                        .map(c => {
                            const access = PermissionSubscriptionCheck
                                .withUrl(c.key).hasPermissionTo();
                            return {
                                ...c,
                                locked: !access.subscription,
                                hidden: !access.permission,
                                parentLabel,
                            };
                        })
                        .filter(c => !c.hidden && !c.locked),
                ].flat();

                // console.log('aaa globalSearch globalSearchChildren - newArr', {a, newArr});
            }

            // Modules without subgroup - eg Dashboard
            return newArr;
        });

    // console.log('aaa globalSearch flattenValidRoutes', flattenValidRoutes);

    // // Check if any route do not have parentLabel
    // console.log('aaa globalSearch noParentLabel', flattenValidRoutes.filter(r => !r.parentLabel));

    // // Check duplicate labels (eg: Payments)
    // const duplicates = _.chain(flattenValidRoutes)
    //     .groupBy('label').filter(v => v.length > 1).uniq()
    //     .value();
    // console.log('aaa globalSearch duplicates', duplicates);

    return flattenValidRoutes;
};

const expandMatchesIfAllSearchLabel = fuseResultsArr => {
    // if a fuse result item has all matches as globalSearchKeywords.searchLabel (instead of label / parentLabel),
    // duplicate the result item and make each match as a separate item
    const expandMatches = fuseResultsArr.reduce((acc, fuseResItem) => {
        const shouldExpand = fuseResItem.matches.every(m => m.key === 'globalSearchKeywords.searchLabel');
        if (shouldExpand) {
            const matches = fuseResItem.matches.map((matchItem => {
                const newFuseResItem = {
                    ...fuseResItem,
                    matches: [matchItem],
                };
                return newFuseResItem;
            }));
            return [...acc, ...matches];
        }
        return [...acc, fuseResItem];
    }, []);
    return expandMatches;
};

/**
 * To make sure the results are grouped togerther based on parent Label.
 * Most similar term's group will still be ranked first.
 * EG: Term: New Invoice, Group: Invoices
 * @param {Object[]} fuseResults array returned by fusejs, includes the item and score
 * @returns a rearranged array of object of same structure, grouped by parent's label
 */
export const sortGroupByPagesResults = fuseResults => {
    if (!fuseResults.length)
        return fuseResults;

    const expandedFuseResults = expandMatchesIfAllSearchLabel(fuseResults);
    const groupedByParentLabel = _.groupBy(expandedFuseResults,
        obj => obj.item.parentLabel || obj.item.label || 'no parent');

    // assume: index 0 is the most similar to search term (lowest fuse score), fuse js is sorted
    const mostSimilarGroup = expandedFuseResults[0]?.item.parentLabel || expandedFuseResults[0]?.item.label || 'no parent';

    const { [mostSimilarGroup]: mostSimilarGroupArr, ...restGroups } = groupedByParentLabel;

    const otherGroupsArr = Object.values(restGroups).flat();

    // make sure that the group with the most similar term is placed in front
    const groupedRes = [...mostSimilarGroupArr, ...otherGroupsArr];
    // console.log('aaa fuseResult', { fuseResults, groupedByParentLabel, expandedFuseResults, groupedRes, mostSimilarGroupArr, otherGroupsArr });

    return groupedRes;
};
